import {ListItemViewModel} from "../../../infrastructure/models/list-item.view-model";

export class StandingWidgetTabViewModel extends ListItemViewModel {
  type: Number = null;

  constructor(index: Number, type: Number, name: String, active: Boolean) {
    super({index, name, active});

    this.type = type;
  }
}



